import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherComponent } from './weather.component';
import { WeatherService } from './weather.service';
import { SharedProviderModule } from '../shared/shared.module';
import { ForecastComponent } from './forecast/forecast.component';

@NgModule({
  imports: [
    CommonModule,
    SharedProviderModule
  ],
  declarations: [WeatherComponent, ForecastComponent],
  exports: [WeatherComponent, ForecastComponent],
  providers: [WeatherService]
})
export class WeatherModule {
}
